import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {DocumentId} from "common/types/document";
import {DocumentContextValues} from "common_components/client_context";

export default function updateDocumentContext(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_CONTEXT_UPDATE,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      documentId: DocumentId,
      values: DocumentContextValues,
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}` +
            `/document/${documentId}`,
          {
            client_context: values.clientContext,
            client_context_id: values.clientContextId,
          },
          {withCredentials: true},
        )
        .then(response => response.data);
    },
  );
}
